export function calcularPrecoVenda({ custoAnuncio, margemAlvo, canal, modoMargem = 'percentual' }) {
    const { txHolding, txVariavel, ads, imposto } = canal;
    const isMeli = canal.id === 'meli';

    let precoVenda, txFixa;

    if (isMeli) {
        txFixa = canal.txFixaBaixa;
        let denominador = modoMargem === 'percentual'
            ? 1 - txVariavel - ads - imposto - margemAlvo
            : 1 - txVariavel - ads - imposto;

        if (denominador <= 0) return { erro: 'Margem impossível' };

        precoVenda = modoMargem === 'percentual'
            ? (custoAnuncio + txHolding + txFixa) / denominador
            : (custoAnuncio + txHolding + txFixa + margemAlvo) / denominador;

        if (precoVenda >= canal.limiarTxFixa) {
            txFixa = canal.txFixaAlta;
            precoVenda = modoMargem === 'percentual'
                ? (custoAnuncio + txHolding + txFixa) / denominador
                : (custoAnuncio + txHolding + txFixa + margemAlvo) / denominador;
        }
    } else {
        txFixa = canal.txFixa;
        const denominador = modoMargem === 'percentual'
            ? 1 - txVariavel - ads - imposto - margemAlvo
            : 1 - txVariavel - ads - imposto;

        if (denominador <= 0) return { erro: 'Margem impossível' };

        precoVenda = modoMargem === 'percentual'
            ? (custoAnuncio + txHolding + txFixa) / denominador
            : (custoAnuncio + txHolding + txFixa + margemAlvo) / denominador;
    }

    const txVariavelValor = precoVenda * txVariavel;
    const adsValor = precoVenda * ads;
    const impostoValor = precoVenda * imposto;
    const cav = txHolding + txFixa + txVariavelValor + adsValor + impostoValor;
    const recebe = precoVenda - cav;
    const margem = recebe - custoAnuncio;
    const margemPercent = precoVenda > 0 ? margem / precoVenda : 0;

    return {
        precoVenda,
        txHolding,
        txFixa,
        txVariavel: canal.txVariavel,
        txVariavelValor,
        ads: canal.ads,
        adsValor,
        imposto: canal.imposto,
        impostoValor,
        cav,
        recebe,
        custoAnuncio,
        margem,
        margemPercent,
        usouTaxaAlta: isMeli && txFixa === canal.txFixaAlta
    };
}

export function calcularComPrecoFixo(precoVenda, custoAnuncio, canal) {
    const { txHolding, txVariavel, ads, imposto } = canal;
    const isMeli = canal.id === 'meli';

    let txFixa = isMeli
        ? (precoVenda >= canal.limiarTxFixa ? canal.txFixaAlta : canal.txFixaBaixa)
        : canal.txFixa;

    const txVariavelValor = precoVenda * txVariavel;
    const adsValor = precoVenda * ads;
    const impostoValor = precoVenda * imposto;
    const cav = txHolding + txFixa + txVariavelValor + adsValor + impostoValor;
    const recebe = precoVenda - cav;
    const margem = recebe - custoAnuncio;
    const margemPercent = precoVenda > 0 ? margem / precoVenda : 0;

    return { precoVenda, margem, margemPercent };
}

export function aplicarDesconto(resultado, desconto, modoDesconto) {
    if (!resultado || resultado.erro || desconto <= 0) return resultado;

    if (modoDesconto === 'direto') {
        const pvOriginal = resultado.precoVenda;
        const pvComDesconto = pvOriginal * (1 - desconto);
        const descontoValor = pvOriginal - pvComDesconto;

        const txVariavelValor = pvComDesconto * resultado.txVariavel;
        const adsValor = pvComDesconto * resultado.ads;
        const impostoValor = pvComDesconto * resultado.imposto;
        const cav = resultado.txHolding + resultado.txFixa + txVariavelValor + adsValor + impostoValor;
        const recebe = pvComDesconto - cav;
        const margem = recebe - resultado.custoAnuncio;
        const margemPercent = pvComDesconto > 0 ? margem / pvComDesconto : 0;

        return {
            ...resultado,
            pvProjetado: pvOriginal,
            descontoPercent: desconto,
            descontoValor,
            precoVenda: pvComDesconto,
            txVariavelValor,
            adsValor,
            impostoValor,
            cav,
            recebe,
            margem,
            margemPercent,
            modoDesconto: 'direto'
        };
    } else {
        const pvFinal = resultado.precoVenda;
        const pvDeExibido = pvFinal / (1 - desconto);
        const descontoValor = pvDeExibido - pvFinal;

        return {
            ...resultado,
            pvProjetado: pvDeExibido,
            descontoPercent: desconto,
            descontoValor,
            precoVenda: pvFinal,
            modoDesconto: 'preservar'
        };
    }
}

export function calcularReverso(precoVenda, custoAnuncio, canal) {
    if (!precoVenda || precoVenda <= 0) return { erro: 'Informe o preço de venda' };
    if (custoAnuncio < 0) return { erro: 'Custo inválido' };

    const { txHolding, txVariavel, ads, imposto } = canal;
    const isMeli = canal.id === 'meli';

    let txFixa;
    if (isMeli) {
        txFixa = precoVenda >= canal.limiarTxFixa ? canal.txFixaAlta : canal.txFixaBaixa;
    } else {
        txFixa = canal.txFixa;
    }

    const txVariavelValor = precoVenda * txVariavel;
    const adsValor = precoVenda * ads;
    const impostoValor = precoVenda * imposto;

    const cav = txHolding + txFixa + txVariavelValor + adsValor + impostoValor;
    const recebe = precoVenda - cav;
    const margem = recebe - custoAnuncio;
    const margemPercent = precoVenda > 0 ? margem / precoVenda : 0;

    let saudeIndicador, saudeCor, saudeTexto;
    if (margem < 0) {
        saudeIndicador = '💀';
        saudeCor = '#991b1b';
        saudeTexto = 'Prejuízo';
    } else if (margemPercent < 0.10) {
        saudeIndicador = '❌';
        saudeCor = '#ef4444';
        saudeTexto = 'Crítica';
    } else if (margemPercent < 0.20) {
        saudeIndicador = '⚠️';
        saudeCor = '#f59e0b';
        saudeTexto = 'Apertada';
    } else {
        saudeIndicador = '✅';
        saudeCor = '#10b981';
        saudeTexto = 'Saudável';
    }

    return {
        precoVenda,
        txHolding,
        txFixa,
        txVariavelValor,
        adsValor,
        impostoValor,
        cav,
        recebe,
        margem,
        margemPercent,
        usouTaxaAlta: isMeli && txFixa === canal.txFixaAlta,
        saudeIndicador,
        saudeCor,
        saudeTexto
    };
}
